export type ModeType = "DEV" | "TEST" | "PROD" | "MAINTENANCE";

export const APP_MODES: { [key: string]: number } = {
  dev         :  2 ,
  test        :  1 ,
  prod        :  0 ,
  maintenance : -1
};

export const getModeName = (appState: number): ModeType => {

  switch (appState) 
   {
    case APP_MODES.dev         : return "DEV"
    case APP_MODES.test        : return "TEST"
    case APP_MODES.maintenance : return "MAINTENANCE"
    default                    : return "PROD"
   }
};
